// src/components/shared/SectionTitle.js
import React from "react";

const SectionTitle = ({ children }) => {
	return (
		<div className="mb-9 md:mb-10">
			<h2 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
				{children}
			</h2>
			<span className="mt-3 block h-1 w-12 rounded-full bg-gradient-to-r from-brand-600 to-brand-400"></span>
		</div>
	);
};

export default SectionTitle;
